import React from 'react';
import PropTypes from 'prop-types';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Label,
  Row,
} from 'reactstrap';

class CreateRolePage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Page
        className="CreateRolepage"
        title="Create Role"
        breadcrumbs={[
          { name: 'Role', active: false },
          { name: 'Create Role', active: true },
        ]}
      >
        <Row>
          <Col xl={6} lg={6} md={12}>
            <Card style={{ height: 'auto' }} className="AddFormCard">
              <CardHeader>
                Add New Role
                <div className="ml-auto ps-action-button">
                  <Button className="theme-button theme-button-secondary">
                    Cancel
                  </Button>
                  <Button className="theme-button theme-button-primary">
                    Save
                  </Button>
                </div>
              </CardHeader>
              <CardBody>
                <Form onSubmit={this.handleSubmit} className="AuthForm">
                  <FormGroup>
                    <Label for="rolename">Role Name</Label>
                    <Input type="text" name="rolename" />
                  </FormGroup>

                  <div className="space-divider">
                    <Label className="d-block">Company</Label>
                    <Row form>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox" /> View
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox" /> Create
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox" /> Edit
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox" /> Delete
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  <div className="space-divider">
                    <Label className="d-block">Role</Label>
                    <Row form>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox" /> View
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox" /> Create
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox" /> Edit
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox" /> Delete
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  <div className="space-divider">
                    <Label className="d-block">User</Label>
                    <Row form>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox" /> View
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox" /> Create
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox" /> Edit
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input type="checkbox" /> Delete
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
    );
  }
}

// export const STATE_ADD = 'ADD';
// export const STATE_EDIT = 'EDIT';

// CreateRolePage.propTypes = {
//   actionState: PropTypes.oneOf([STATE_ADD, STATE_EDIT]).isRequired,
// };
// CreateRolePage.defaultProps = {
//   actionState: 'ADD',
// };

export default CreateRolePage;
